import { useMemo } from 'react'
import { calcFourBall } from './ggFourBall.js'
import { sampleTeams } from './ggSamplePlayers.js'

// G-FourBall — isolated sandbox. 2v2 best-ball match; uses the first two sample
// teams. calcFourBall ported from GolfGamesScorecard.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GFourBall() {
  const [t1, t2] = useMemo(() => sampleTeams().slice(0, 2), [])
  const r = useMemo(() => calcFourBall(t1, t2), [t1, t2])
  const nm = (t) => t.map((p) => p.name.split(' ')[0]).join(' & ')
  const halved = r.holeResults.filter((x) => x === 'halved').length

  return (
    <div className="card">
      <p className="text-sm mb-3">Best-ball match — winner: <b>{r.winner}</b></p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Team', 'Holes won'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>
          <tr><td style={cell}>Team 1 · {nm(t1)}</td><td style={cell}><b>{r.t1Holes}</b></td></tr>
          <tr><td style={cell}>Team 2 · {nm(t2)}</td><td style={cell}><b>{r.t2Holes}</b></td></tr>
          <tr><td style={cell}>Halved</td><td style={cell}>{halved}</td></tr>
        </tbody>
      </table>
    </div>
  )
}
